import { DropDownList } from "../core/components/dropDownList.js";
import { TextBox } from "../core/components/textBox.js";
import { Button } from "../core/components/button.js";
import { Helper } from "../core/util/helper.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { KeyValuePair } from "../commonInterfaces.js";
import React from "react";

interface FilterProps {
    onTrigger: (filter: string) => void;
    properties: KeyValuePair<string, string>[];
}

interface FilterState {
    filter: string;
    property: string;
}


export class Filter extends React.Component<FilterProps, FilterState>{
    private factory = ComponentHelper.createFactory();
    private id = kendo.guid();
    constructor(props) {
        super(props)
        this.state = {
            filter: "",
            property: this.props.properties[0].Key
        }
        document.addEventListener('keypress', this.onKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener('keypress', this.onKeyPress);
    }

    private onKeyPress = (event) => {
        if (event.key === "Enter" && !Helper.isNullOrEmpty(this.state.filter)) {
            const el = document.querySelector(`div#${this.id} .k-input-solid:focus-within`);
            if (el) {
                event.preventDefault();
                this.trigger();
            }
        }
    }

    private trigger = () => {
        const filter = `startsWith(${this.state.property}, '${this.state.filter}')`;
        this.props.onTrigger(filter)
    }

    render() {
        let dropDown;
        if (this.props.properties.length > 1) {
            const dropDownProps = this.factory.getDefaultDropDownProps();
            dropDownProps.value = this.state.property;
            //
            dropDownProps.dataSource = this.props.properties
            dropDownProps.field.dataTextField = "Value";
            dropDownProps.field.dataValueField = "Key";
            dropDownProps.field.optionLabel = "";
            dropDownProps.onChange = (_, prop) => {
                this.setState({ property: prop })
            }
            dropDown = (
                <>
                    <label>
                        {Helper.getTranslation("Field.Ansprechpartner.funktion")}
                    </label>
                    <div style={{ width: "250px", margin: "0 10px" }}>
                        <DropDownList {...dropDownProps} />
                    </div>
                </>
            );
        }
        


        const textBoxProps = this.factory.getDefaultTextBoxProps();
        textBoxProps.value = this.state.filter;
        textBoxProps.field.triggerOnChange = true;
        textBoxProps.onChange = (_, filter) => {
            this.setState({ filter: filter })
        }

        return (
            <div style={{ display: "flex", alignItems: "center" }} id={this.id} >
                {dropDown}
                <label>
                    {Helper.getTranslation("WebSMS.DataExchangeModule.Protocol.Filter")}
                </label>
                <div style={{ width: "250px", margin: "0 10px" }}>
                    <TextBox {...textBoxProps} />
                </div>
                <Button handleClick={this.trigger} iconName={"magnifying-glass"} buttonStyle={{ borderRadius: "var(--border-radius)" }} readOnly={Helper.isNullOrEmpty(this.state.filter)} />
            </div>
        );
    }
}